import React, { Component } from 'react'

class RelationPMBA extends Component {
    // componentWillUnmount() {
    //     const { cleanData } = this.props;
    //     cleanData();
    // }

    DoSearch = async (data, searchTerm) => {
        const tableReg = document.getElementById(data);
        const searchText = document.getElementById(searchTerm).value.toLowerCase();
        let total = 0;
        // Recorremos todas las filas con contenido de la tabla
        for (let i = 1; i < tableReg.rows.length; i++) {
            // Si el td tiene la clase "noSearch" no se busca en su contenido
            if (tableReg.rows[i].classList.contains("noSearch")) {
                continue;
            }
            let found = false;
            const cellsOfRow = tableReg.rows[i].getElementsByTagName('td');
            // Recorremos todas las celdas
            for (let j = 0; j < cellsOfRow.length && !found; j++) {
                const compareWith = cellsOfRow[j].innerHTML.toLowerCase();
                // Buscamos el texto en el contenido de la celda
                if (searchText.length == 0 || compareWith.indexOf(searchText) > -1) {
                    found = true;
                    total++;
                }
            }
            if (found) {
                tableReg.rows[i].style.display = '';
            } else {
                // si no ha encontrado ninguna coincidencia, esconde la
                // fila de la tabla
                tableReg.rows[i].style.display = 'none';
            }
        }
        // mostramos las coincidencias
        const lastTR = tableReg.rows[tableReg.rows.length - 1];
        const td = lastTR.querySelector("td");
        lastTR.classList.remove("hide", "red");
        if (searchText == "") {
            lastTR.classList.add("hide");
        } else if (total) {
            // td.innerHTML="Se ha encontrado "+total+" coincidencia"+((total>1)?"s":"");
        } else {
            // lastTR.classList.add("red");
            // td.innerHTML="No se han encontrado coincidencias";
        }
    }

    RefreshRelationModel = (RelationModel) => {
        const { RefreshRelationModel } = this.props
        RefreshRelationModel(RelationModel);
    }

    ChangePayMethodCode = (index) => {
        const { RelationModel, PaymentMethods } = this.props
        let payMethod = PaymentMethods[index];
        RelationModel.idPMBO = payMethod.idPMBO || '';
        RelationModel.codePayMethod = payMethod.code || '';
        RelationModel.namePayMethod = payMethod.name || '';
        this.RefreshRelationModel(RelationModel);
    }

    ChangeAcctCode = (index) => {
        const { RelationModel, Accounts } = this.props
        let account = Accounts[index];
        RelationModel.AcctCode = account.AcctCode || '';
        RelationModel.AcctName = account.AcctName || '';
        this.RefreshRelationModel(RelationModel);
    }

    DeleteAccountRelations = (index) => {
        const { DeleteAccountRelations } = this.props
        DeleteAccountRelations(index);
    }

    render() {
        const { Accounts, PaymentMethods, RelationModel, AddRelation, AccountsRelated, AddRelationsToSucursal, AddPayMethod, SucursalModel } = this.props
        return (
            <>
                <div className="modal fade" id="relationPMBABO" data-keyboard="false" tabIndex="-1" aria-labelledby="searchModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-xl">
                        <div className="modal-content">
                            <div className="modal-header" style={{ background: "#343A40" }}>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" style={{ color: "white" }} /*onClick={cleanData}*/>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className='row'>
                                    <div className='col-12 col-md-5 p-4'>
                                        
                                        <div className='row mb-3'>
                                            <div className='col-6'>
                                                <h5>Métodos de pago</h5>
                                            </div>
                                            <div className='col-6 text-right'>
                                                <button type="button" className="btn btn-outline-secondary" onClick={() => AddPayMethod(true)}>
                                                    <i className="fa fa-plus " aria-hidden="true" />
                                                </button>
                                            </div>

                                        </div>
                                        <input
                                            type="text"
                                            className="form-control "
                                            placeholder="Buscar método de pago :"
                                            id="paymentMethodSearch"
                                            onKeyUp={() => this.DoSearch("methods", "paymentMethodSearch")}
                                        />

                                        <div className='mt-4 p-4' style={{ border: "1px solid #00000020", height: "31vh", overflowY: "scroll" }}>
                                            <table id="methods">
                                                {/* <thead>
                                                    <tr>
                                                        <th scope="col">#</th>
                                                        <th scope="col">Código</th>
                                                        <th scope="col">Nombre</th>
                                                    </tr>
                                                </thead> */}
                                                <tbody>
                                                    {PaymentMethods && PaymentMethods.map((payMethod, index) => {
                                                        let flag = false;
                                                        if (SucursalModel && SucursalModel.ListPayMethods && SucursalModel.ListPayMethods.length > 0) {
                                                            for (let index = 0; index < SucursalModel.ListPayMethods.length; index++) {
                                                                const addPayment = SucursalModel.ListPayMethods[index];
                                                                if (Number(addPayment.idPMBO) === Number(payMethod.idPMBO)) {
                                                                    flag = true;
                                                                }
                                                            }
                                                        }

                                                        if (AccountsRelated && AccountsRelated.length > 0) {
                                                            for (let i = 0; i < AccountsRelated.length; i++) {
                                                                const accntRelated = AccountsRelated[i];
                                                                if (Number(accntRelated.idPMBO) === Number(payMethod.idPMBO)) {
                                                                    flag = true;
                                                                }
                                                            }
                                                        }
                                                        return (
                                                            <tr className='mt-2 mb-2' key={index}>
                                                                <td>{payMethod.code ?? ''}</td>
                                                                <td>{payMethod.name ?? ''}</td>
                                                                <td>
                                                                    <input
                                                                        type="radio"
                                                                        disabled={flag}
                                                                        onChange={() => !flag ? this.ChangePayMethodCode(index) : ''}
                                                                        checked={RelationModel && RelationModel.idPMBO === payMethod.idPMBO ? true : false}
                                                                    />
                                                                </td>



                                                            </tr>
                                                        )
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className='col-12 col-md-2 text-center' style={{ marginTop: '17%' }}>
                                        <button
                                            type="button"
                                            className="btn btn-outline-secondary"
                                            onClick={() => AddRelation()}
                                        >
                                            <i className="fa fa-link mr-2" aria-hidden="true" />
                                            Relacionar
                                        </button>
                                    </div>
                                    <div className='col-12 col-md-5 p-4'>
                                        <h5>Cuentas de mayor</h5>
                                        <input
                                            type="text"
                                            className="form-control"
                                            style={{marginTop: "25px"}}
                                            placeholder="Buscar cuenta de mayor:"
                                            id="glAccountsSearch"
                                            onKeyUp={() => this.DoSearch("glAccounts", "glAccountsSearch")}
                                        />
                                        <div className='mt-4 p-4' style={{ border: "1px solid #00000020", height: "31vh", overflowY: "scroll" }}>
                                            <table id="glAccounts">
                                                {/* <thead>
                                                    <tr>
                                                        <th scope="col">#</th>
                                                        <th scope="col">Código</th>
                                                        <th scope="col">Nombre</th>
                                                    </tr>
                                                </thead> */}
                                                <tbody>
                                                    {!!Accounts && Accounts.map((acct, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                {/* <th scope="row"> */}
                                                                    <td>
                                                                        <input
                                                                            type="radio"
                                                                            onChange={() => this.ChangeAcctCode(index)}
                                                                            checked={RelationModel && RelationModel.AcctCode === acct.AcctCode ? true : false}
                                                                        />
                                                                    </td>
                                                                {/* </th> */}
                                                                <td>{acct.AcctCode ?? ''}</td>
                                                                <td>{acct.AcctName ?? ''}</td>


                                                            </tr>
                                                        )
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-12 p-4'>

                                        <div style={{ border: "1px solid #00000020", height: "18vh", overflowY: "scroll" }}>
                                        <div className="table-responsive">
                                            <table className="table response" style={{ marginBottom: 0 }}>
                                                <thead>
                                                    <tr>
                                                        <th scope="col">#</th>
                                                        <th scope="col">Método de Pago</th>
                                                        <th scope="col">Código cuenta</th>
                                                        <th scope="col">Nombre cuenta </th>
                                                        <th scope="col"></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {!!AccountsRelated && AccountsRelated.map((relation, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <td>{index + 1}</td>
                                                                <td>{relation.namePayMethod ?? ''}</td>
                                                                <td>{relation.AcctCode ?? ''}</td>
                                                                <td>{relation.AcctName ?? ''}</td>
                                                                <td>
                                                                    <button className='btn btn-outline-danger' onClick={() => this.DeleteAccountRelations(index)}>
                                                                        <i className="fas fa-trash-alt" aria-hidden="true" size="10" />
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })}

                                                </tbody>

                                            </table>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn botonCorrect" onClick={AddRelationsToSucursal}>
                                    Guardar relaciones
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

            </>
        )
    }
}


export default RelationPMBA
